
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/layout/Footer';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Sitemap = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-green-50">
      <Helmet>
        <title>Sitemap | The PEO App</title>
        <meta name="description" content="Navigate The PEO App's website with our comprehensive sitemap. Find information about PEO services, state-specific guides, and resources for businesses." />
        <link rel="canonical" href="https://thepeoapp.com/sitemap" />
      </Helmet>
      
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-12">Sitemap</h1>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
            {/* Main Pages */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">Main Pages</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-gray-700 hover:text-[#00a86b] hover:underline">Home</Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-700 hover:text-[#00a86b] hover:underline">About Us</Link>
                </li>
                <li>
                  <Link to="/peo-vetting-process" className="text-gray-700 hover:text-[#00a86b] hover:underline">PEO Vetting Process</Link>
                </li>
                <li>
                  <Link to="/partnerships" className="text-gray-700 hover:text-[#00a86b] hover:underline">Partnerships</Link>
                </li>
                <li>
                  <Link to="/application" className="text-gray-700 hover:text-[#00a86b] hover:underline">PEO Application</Link>
                </li>
              </ul>
            </div>
            
            {/* PEO Services */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">PEO Services</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/services/payroll" className="text-gray-700 hover:text-[#00a86b] hover:underline">Payroll Processing</Link>
                </li>
                <li>
                  <Link to="/services/benefits" className="text-gray-700 hover:text-[#00a86b] hover:underline">Employee Benefits</Link>
                </li>
                <li>
                  <Link to="/services/hr-compliance" className="text-gray-700 hover:text-[#00a86b] hover:underline">HR Compliance</Link>
                </li>
                <li>
                  <Link to="/services/workers-comp" className="text-gray-700 hover:text-[#00a86b] hover:underline">Workers' Compensation</Link>
                </li>
                <li>
                  <Link to="/services/risk-management" className="text-gray-700 hover:text-[#00a86b] hover:underline">Risk Management</Link>
                </li>
              </ul>
            </div>
            
            {/* States - Popular */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">Popular States</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/states" className="text-gray-700 hover:text-[#00a86b] hover:underline">All 50 States</Link>
                </li>
                <li>
                  <Link to="/states/california" className="text-gray-700 hover:text-[#00a86b] hover:underline">California PEOs</Link>
                </li>
                <li>
                  <Link to="/states/texas" className="text-gray-700 hover:text-[#00a86b] hover:underline">Texas PEOs</Link>
                </li>
                <li>
                  <Link to="/states/florida" className="text-gray-700 hover:text-[#00a86b] hover:underline">Florida PEOs</Link>
                </li>
                <li>
                  <Link to="/states/new-york" className="text-gray-700 hover:text-[#00a86b] hover:underline">New York PEOs</Link>
                </li>
              </ul>
            </div>
            
            {/* Northeast States */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">Northeast States</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/states/connecticut" className="text-gray-700 hover:text-[#00a86b] hover:underline">Connecticut PEOs</Link>
                </li>
                <li>
                  <Link to="/states/maine" className="text-gray-700 hover:text-[#00a86b] hover:underline">Maine PEOs</Link>
                </li>
                <li>
                  <Link to="/states/massachusetts" className="text-gray-700 hover:text-[#00a86b] hover:underline">Massachusetts PEOs</Link>
                </li>
                <li>
                  <Link to="/states/new-hampshire" className="text-gray-700 hover:text-[#00a86b] hover:underline">New Hampshire PEOs</Link>
                </li>
                <li>
                  <Link to="/states/new-jersey" className="text-gray-700 hover:text-[#00a86b] hover:underline">New Jersey PEOs</Link>
                </li>
                <li>
                  <Link to="/states/pennsylvania" className="text-gray-700 hover:text-[#00a86b] hover:underline">Pennsylvania PEOs</Link>
                </li>
                <li>
                  <Link to="/states/rhode-island" className="text-gray-700 hover:text-[#00a86b] hover:underline">Rhode Island PEOs</Link>
                </li>
                <li>
                  <Link to="/states/vermont" className="text-gray-700 hover:text-[#00a86b] hover:underline">Vermont PEOs</Link>
                </li>
              </ul>
            </div>
            
            {/* Midwest States */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">Midwest States</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/states/illinois" className="text-gray-700 hover:text-[#00a86b] hover:underline">Illinois PEOs</Link>
                </li>
                <li>
                  <Link to="/states/indiana" className="text-gray-700 hover:text-[#00a86b] hover:underline">Indiana PEOs</Link>
                </li>
                <li>
                  <Link to="/states/iowa" className="text-gray-700 hover:text-[#00a86b] hover:underline">Iowa PEOs</Link>
                </li>
                <li>
                  <Link to="/states/michigan" className="text-gray-700 hover:text-[#00a86b] hover:underline">Michigan PEOs</Link>
                </li>
                <li>
                  <Link to="/states/minnesota" className="text-gray-700 hover:text-[#00a86b] hover:underline">Minnesota PEOs</Link>
                </li>
                <li>
                  <Link to="/states/missouri" className="text-gray-700 hover:text-[#00a86b] hover:underline">Missouri PEOs</Link>
                </li>
                <li>
                  <Link to="/states/ohio" className="text-gray-700 hover:text-[#00a86b] hover:underline">Ohio PEOs</Link>
                </li>
                <li>
                  <Link to="/states/wisconsin" className="text-gray-700 hover:text-[#00a86b] hover:underline">Wisconsin PEOs</Link>
                </li>
              </ul>
            </div>
            
            {/* User Account */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">User Account</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/login" className="text-gray-700 hover:text-[#00a86b] hover:underline">Login</Link>
                </li>
                <li>
                  <Link to="/signup" className="text-gray-700 hover:text-[#00a86b] hover:underline">Sign Up</Link>
                </li>
              </ul>
            </div>
            
            {/* Legal Information */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">Legal Information</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/terms" className="text-gray-700 hover:text-[#00a86b] hover:underline">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-gray-700 hover:text-[#00a86b] hover:underline">Privacy Policy</Link>
                </li>
              </ul>
            </div>
            
            {/* Support */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">Support</h2>
              <ul className="space-y-2">
                <li>
                  <a href="mailto:info@thepeoapp.com" className="text-gray-700 hover:text-[#00a86b] hover:underline">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Sitemap;
